SupportMainContentWrapperView = require('../../main_content_view')
SupportSearchInputView = require('../../search_input_view')
StepTwoInbentaBaseView = require('./base_view')
SupportAPIHelper = require('../../../helpers/API')

class StepTwoInbentaNLPView extends StepTwoInbentaBaseView

  initialize: ->
    if Groupon.Support.FeatureFlagModel.isSearchBasedDropDownsEnabled()
      window.simulateDropdownSelection()
      @initiateInbentaEvents()
    StepTwoInbentaBaseView::initialize.apply(this, arguments)
    @searchInputView = new SupportSearchInputView()

  fetchAndRenderCategory : (contentWrapper) ->
    unless @dropDownCombinationsModel.has('flexStepThree')
      startTimer("t_dc")
      @dropDownCombinationsModel.fetch
        data : null
        success: ( model, response, options ) =>
          stopTimer("t_dc")
          @handleDropdownsCb(contentWrapper, response)
        error: ( model, response, options ) =>
          stopTimer("t_dc")
          @handleDropdownsCb(contentWrapper, response)

  renderInbentaSearchBox: (contentWrapper)->
    @searchInputView.render()
    contentWrapper.append(@searchInputView.el)

  handleDropdownsCb: (contentWrapper, response )->
    @setFlexStepThreeComb response

  helpContentSuccess: (results) =>
    @spinnerView.hide({ container: $('#nlp-spinner') })
    Groupon.Support.ContentModel.flexibleStepThree = results[0] if results?.length? > 0
    @flexStepThree['responseReceived'] = true
    if @inbentaEventType then @callInbentaEventCb()

  fetchDropdownCombinations: ()->
    @dropDownCombinationsModel.attributes

  setFlexStepThreeComb: (response) =>
    @flexStepThree.dropdownCombinations = response.flexStepThree?['dropdownCombinations']
    @flexStepThree['responseReceived'] = true

  helpContentError: () =>
    @spinnerView.hide({ container:$('#nlp-spinner') })
    @flexStepThree['responseReceived'] = true
    if @inbentaEventType? then return @callInbentaEventCb()

  callInbentaEventCb: ->
    if @inbentaEventType is 'solved-feedback'
      @step2SolvedFeedBackCb()
    else if @inbentaEventType is 'step2-continue-disabled'
      @step2ContinueDisabledCb()
    else if @inbentaEventType is 'step2-continue-enabled'
      @step2ContinueEnabledCb()

  step2SolvedFeedBackCb: ->
    if @flexStepThree?['allowed'] and not @flexStepThree?['responseReceived']
      return @inbentaEventType = 'solved-feedback'
    @isInbentaContentShown = true
    @sendTrackyCallForHelpContentBeingShown true
    $('.direct-ticket').css('display','none')
    $('.issue-check').css('display', 'block')
    $('#contact-us').attr('disabled', false)

  step2ContinueDisabledCb: (event)->
    if @flexStepThree?['allowed'] and not @flexStepThree?['responseReceived']
      return @inbentaEventType = 'step2-continue-disabled'
    @isInbentaContentShown = true
    @sendTrackyCallForHelpContentBeingShown true
    $('.issue-check').css('display', 'none')
    $('.direct-ticket').css('display', 'block')
    $('#continueToTicket').attr('disabled', true)

  step2ContinueEnabledCb: (event)->
    if @flexStepThree?['allowed'] and not @flexStepThree?['responseReceived']
      return @inbentaEventType = 'step2-continue-enabled'
    @isInbentaContentShown = true
    @sendTrackyCallForHelpContentBeingShown false
    $('.issue-check').css('display', 'none')
    $('.direct-ticket').css('display', 'block')
    $('#continueToTicket').attr('disabled', false)

  fetchHelpContent: (inbentaEventType)->
    @inbentaEventType = inbentaEventType
    if @isFlexStepThreeAllowed()
      @spinnerView.show({ container:$('#nlp-spinner') })
      @resetFlexStepThree()
      urls = @getHelpContentPaths()
      data = @getTaglines()
      @contentRequests = SupportAPIHelper.parallel urls, data, @getHelpContentSuccessCb(), @getHelpContenteErrorCb(), false, "t_ic", 60000
    else
      Groupon.Support.ContentModel.flexibleStepThree = null
      @callInbentaEventCb()
    @setFlexibleContactChannels()

  simulatedDropdownsCb: (inbentaEventType)=>
    @fetchHelpContent(inbentaEventType)

  initiateInbentaEvents: ()=>
    $(document).bind('step2-solved-feedback',(event)=>
      @step2SolvedFeedBackCb(event)
    )

    $(document).bind('step2-continue-disabled', (event)=>
      @step2ContinueDisabledCb(event)
    )

    $(document).bind('step2-continue-enabled', (event)=>
      @step2ContinueEnabledCb(event)
    )

window.simulateDropdownSelection = () ->
    if Groupon.Support.FeatureFlagModel.isSearchBasedDropDownsEnabled()
      window.InbentaHelpWizard::simulateDropdownSelection = (targetElement)->
        category = ''
        subcategory = ''
        $(targetElement).find('.hwcategories').each(()->
          if(!category || !subcategory)
            currentCat = $.trim($(this).find('.hwcategory').text())
            currentSubcat = $.trim($(this).find('.hwsubcategory').text())
            category = currentCat
            subcategory = currentSubcat
        )

        if(!@step2firstDropdownSelection && (!category || !subcategory))
          category = @step2defaultDropdownSelection.category
          subcategory = @step2defaultDropdownSelection.subcategory

        if(category && subcategory)
          Groupon.Support.Inbenta.Category =
            text: category
            id: @getDropdownCategoryKeyValue(category)
          Groupon.Support.Inbenta.SubCategory =
            text : subcategory
            id : @getDropdownCategoryKeyValue(subcategory)

          searchText = $('.inbenta-searchform-container #inbenta-searchform #inbenta-searchinput').val() || ""
          if searchText?.length > 0
            searchText = searchText.trim()

          if (searchText?.length is 0 && $(targetElement).hasClass('hwresult'))
            @step2firstDropdownSelection = false
            Groupon.Support.StepTwoView.simulatedDropdownsCb('step2-continue-enabled')
            Groupon.Support.Inbenta.searchInputIssue = Groupon.Support.Inbenta.SubCategory?.text
          else
            @step2firstDropdownSelection = true
            Groupon.Support.StepTwoView.simulatedDropdownsCb(null)
            Groupon.Support.Inbenta.searchInputIssue = searchText
        $.event.trigger('simulated-dropdowns')

module.exports = StepTwoInbentaNLPView
